module.exports = __webpack_public_path__ + "static/media/huli_417.b64a0161.gif";